<div class="header-bar">
  <h1>Checklist Categories</h1>
</div>
<div class="content-container">
  <p-table
    [value]="categories"
    [(selection)]="selectedCategory"
    [rows]="5"
    selectionMode="single"
    [paginator]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="title">Category</th>
        <th>Active</th>
        <th pSortableColumn="updated">Updated</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-data>
      <tr (dblclick)="editCategory(data)" (click)="categoryChosen(data)" [pSelectableRow]="data">
        <td>
          <span class="ball" [ngStyle]="{ 'background-color': data.rgb }"></span>
          <span class="title" style=""> &nbsp; {{ data.title }} </span>
        </td>
        <td>
          <span *ngIf="data.isActive"><i class="fa fa-check text-success"></i></span>
          <span *ngIf="!data.isActive"><i class="fa fa-times text-error"></i></span>
        </td>
        <td>
          <span>
            {{ data.updated | date : 'dd/MM/yy' }}
          </span>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <!---
  <p-dataTabl [value]="categories" [(selection)]="selectedCategory" [rows]="5" selectionMode="single"
               (onRowDblclick)="editCategory()"
               paginator="true"
               (onRowClick)="categoryChosen($event)">
    <p-column field="title" header="Category Name" [sortable]="tru">
      <ng-template let-data="rowData" pTemplate="body">
        <span class="ball" [ngStyle]="{'background-color': data.rgb }"></span>
        <span class="title" style="">
        &nbsp; {{ data.title }}
      </span>
      </ng-template>
    </p-column>
    <p-column field="isActive" header="Active" [sortable]="tru" [style]="{'width':'100px','text-align':'center'}">
      <ng-template let-data="rowData" pTemplate="body">
        <span *ngIf="data.isActive"><i class="fa fa-check text-success"></i></span>
        <span *ngIf="!data.isActive"><i class="fa fa-times text-error"></i></span>
      </ng-template>
    </p-column>
    <p-column field="updated" header="Updated" [sortable]="tru" [style]="{'width':'100px', 'text-align':'center'}">
      <ng-template let-data="rowData" pTemplate="body">
      <span>
        {{ data.updated | date: "dd/MM/yy"}}
      </span>
      </ng-template>
    </p-column>
  </p-dataTable>

  -->

  <div class="text-right mt-2">
    <button
      pButton
      label="Edit"
      (click)="editCategory(selectedCategory)"
      *ngIf="selectedCategory"
    ></button>
    <button pButton label="Add Category" (click)="addCategory()"></button>
  </div>

  <span *ngIf="selectedCategory">
    <h2>{{ selectedCategory?.title }} Sub Categories</h2>

    <p-table
      [value]="subCategories"
      [(selection)]="selectedSubCategory"
      [rows]="5"
      [paginator]="true"
      selectionMode="single"
    >
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="title">Title</th>
          <th pSortableColumn="description">Description</th>
          <th pSortableColumn="isActive">Active</th>
          <th pSortableColumn="weighting">Weighting</th>
          <th>OnTime Collection</th>
          <th>OnTime Delivery</th>
          <th pSortableColumn="updated">Updated</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-data>
        <tr (dblclick)="editSubCategory(data)" [pSelectableRow]="data">
          <td>{{ data.title }}</td>
          <td>{{ data.description }}</td>
          <td>
            <span *ngIf="data.isActive"><i class="fa fa-check text-success"></i></span>
            <span *ngIf="!data.isActive"><i class="fa fa-times text-error"></i></span>
          </td>
          <td>
            <span>{{ data.weighting }}</span>
          </td>
          <td>
            <span *ngIf="data.measureOnTimeOnCollection"
              ><i class="fa fa-check text-success"></i
            ></span>
            <span *ngIf="!data.measureOnTimeOnCollection"
              ><i class="fa fa-times text-error"></i
            ></span>
          </td>
          <td>
            <span *ngIf="data.measureOnTimeOnDelivery"
              ><i class="fa fa-check text-success"></i
            ></span>
            <span *ngIf="!data.measureOnTimeOnDelivery"
              ><i class="fa fa-times text-error"></i
            ></span>
          </td>
          <td>
            {{ data.updated | date : 'dd/MM/yy' }}
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!---
  <p-dataTabl [value]="subCategories" [(selection)]="selectedSubCategory" [rows]="5"
               (onRowDblclick)="editSubCategory()"
               paginator="true"
               selectionMode="single">
    <p-column field="title" header="Title" [sortable]="tru">
    <ng-template let-data="rowData" pTemplate="body">
      <span>
        {{ data.title }}
      </span>
    </ng-template>
    </p-column>
    <p-column field="description" header="Description" [sortable]="tru">
    <ng-template let-data="rowData" pTemplate="body">
      <span>
        {{ data.description }}
      </span>
    </ng-template>
    </p-column>
    <p-column field="isActive" header="Active" [sortable]="tru" [style]="{'width':'100px','text-align':'center'}">
      <ng-template let-data="rowData" pTemplate="body">
        <span *ngIf="data.isActive"><i class="fa fa-check text-success"></i></span>
        <span *ngIf="!data.isActive"><i class="fa fa-times text-error"></i></span>
      </ng-template>
    </p-column>
    <p-column field="weighting" header="Weighting" [sortable]="tru"
              [style]="{'width':'100px','text-align':'center'}">
      <ng-template let-data="rowData" pTemplate="body">
        <span>
          {{ data.weighting }}
        </span>
      </ng-template>
      </p-column>
      <p-column field="measureOnTimeOnCollection" header="Ontime Collection" [sortable]="tru"
                [style]="{'width':'100px','text-align':'center'}">
        <ng-template let-data="rowData" pTemplate="body">
          <span *ngIf="data.measureOnTimeOnCollection"><i class="fa fa-check text-success"></i></span>
          <span *ngIf="!data.measureOnTimeOnCollection"><i class="fa fa-times text-error"></i></span>
        </ng-template>
      </p-column>
      <p-column field="measureOnTimeOnDelivery" header="Ontime Delivery" [sortable]="tru"
                [style]="{'width':'100px','text-align':'center'}">
        <ng-template let-data="rowData" pTemplate="body">
          <span *ngIf="data.measureOnTimeOnDelivery"><i class="fa fa-check text-success"></i></span>
          <span *ngIf="!data.measureOnTimeOnDelivery"><i class="fa fa-times text-error"></i></span>
        </ng-template>
      </p-column>
    <p-column field="updated" header="Updated" [sortable]="tru" [style]="{'width':'100px', 'text-align':'center'}">
      <ng-template let-data="rowData" pTemplate="body">
      <span>
        {{ data.updated | date: "dd/MM/yy"}}
      </span>
      </ng-template>
    </p-column>
  </p-dataTable>
  --->

    <div class="text-right mt-2">
      <button
        pButton
        label="Edit"
        (click)="editSubCategory(selectedSubCategory)"
        *ngIf="selectedSubCategory"
      ></button>
      <button pButton label="Add SubCategory" (click)="addSubCategory()"></button>
    </div>
  </span>
</div>

<p-dialog
  header="Checklist Category"
  [(visible)]="showEditCategory"
  [modal]="true"
  [style]="{ width: '500px' }"
>
  <form [formGroup]="categoryForm">
    <div class="ui-g-12">
      <div class="ui-g-4">
        <label for="title">Title</label>
      </div>
      <div class="ui-g-8">
        <input
          pInputText
          name="title"
          maxlength="50"
          style="width: 100%"
          formControlName="title"
          autocomplete="off"
          id="title"
        />
      </div>

      <div class="ui-g-4">
        <label for="title">Active</label>
      </div>
      <div class="ui-g-8">
        <p-inputSwitch formControlName="isActive"></p-inputSwitch>
      </div>

      <div class="ui-g-4">Highlight Color</div>

      <div class="ui-g-8">
        <!-- Documentation: https://github.com/scttcper/ngx-color -->
        <color-circle
          [color]="f.rgb.value"
          (onChangeComplete)="changeComplete($event)"
        ></color-circle>
      </div>

      <div class="ui-g-4">Sample</div>

      <div class="ui-g-8">
        <span class="sample-title" id="sample-title" [ngStyle]="{ 'outline-color': f.rgb.value }">
          <span class="sample-category" [ngStyle]="{ 'background-color': f.rgb.value }">{{
            f.title.value
          }}</span>
          <span class="sample-subcategory" [ngStyle]="{ color: f.rgb.value }">Sub Category</span>
        </span>
      </div>

      <div class="ui-g-4">&nbsp;</div>
      <div class="ui-g-8">
        <button
          (click)="saveCategory()"
          pButton
          [label]="saving ? 'Wait..' : 'Save'"
          [disabled]="saving || !categoryForm.valid"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>

<p-dialog
  header="Sub Category"
  [(visible)]="showEditSubCategory"
  [modal]="true"
  [style]="{ width: '700px' }"
>
  <form [formGroup]="subCategoryForm">
    <div class="ui-g">
      <div class="ui-g-4">
        <label for="title">Category</label>
      </div>

      <div class="ui-g-8">
        {{ selectedCategory?.title }}
      </div>

      <div class="ui-g-4">
        <label for="title">Title</label>
      </div>

      <div class="ui-g-8">
        <input
          pInputText
          name="title"
          maxlength="50"
          style="width: 100%"
          formControlName="title"
          autocomplete="off"
          id="title2"
        />
      </div>

      <div class="ui-g-4">
        <label for="description">Description</label>
      </div>
      <div class="ui-g-8">
        <textarea
          pInputTextarea
          name="title"
          style="width: 100%; height: 100px"
          formControlName="description"
          autocomplete="off"
          id="description"
        ></textarea>
      </div>

      <div class="ui-g-4">
        <label for="title">Active</label>
      </div>
      <div class="ui-g-8">
        <p-inputSwitch formControlName="isActive"></p-inputSwitch>
      </div>

      <div class="ui-g-4">
        <label for="title">Weighting</label>
      </div>
      <div class="ui-g-8">
        <input
          pInputText
          name="weighting"
          type="number"
          style="width: 100%"
          formControlName="weighting"
          autocomplete="off"
          id="weighting"
        />
      </div>

      <div class="ui-g-4">
        <label for="title">Ontime Collection</label>
      </div>
      <div class="ui-g-8">
        <p-inputSwitch formControlName="measureOnTimeOnCollection"></p-inputSwitch>
      </div>

      <div class="ui-g-4">
        <label for="title">Ontime Delivery</label>
      </div>
      <div class="ui-g-8">
        <p-inputSwitch formControlName="measureOnTimeOnDelivery"></p-inputSwitch>
      </div>

      <div class="ui-g-4">&nbsp;</div>
      <div class="ui-g-8">
        <button
          (click)="saveSubCategory()"
          pButton
          [label]="saving ? 'Wait..' : 'Save'"
          [disabled]="saving || !subCategoryForm.valid"
        ></button>
      </div>
    </div>
  </form>
</p-dialog>
